import fetchWithAuth from "../utils/fetchWithAuth";
import { buildEndpoint } from "../utils/ApiContext";

export const fetchTopics = async () => {
  try {
    const API_URL = await buildEndpoint("API_FETCH_TOPICS");
    const response = await fetchWithAuth(API_URL);
    if (!response.ok) throw new Error("Error al cargar los tópicos de chat");
    const data = await response.json();
    return data.topics ? data.topics.map(t => ({ id: t.TOPIC_ID, name: t.TOPIC_NAME })) : data.map(t => ({ id: t.TOPIC_ID, name: t.TOPIC_NAME }));
  } catch (error) {
    console.error("Error al intentar cargar los tópicos de chat:", error);
    throw error;
  }
};

export const fetchChatHistory = async topicId => {
  const baseUrl = await buildEndpoint("API_FETCH_CHAT_HISTORY");
  const API_URL = baseUrl.replace("{topic_id}", encodeURIComponent(topicId));
  const res = await fetchWithAuth(API_URL);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
};

export const deleteTopic = async topicId => {
  try {
    const baseUrl = await buildEndpoint('API_DELETE_TOPIC');
    const API_URL = baseUrl.replace("{topic_id}", encodeURIComponent(topicId));
    const response = await fetchWithAuth(API_URL, { method: "DELETE" });
    if (!response.ok) throw new Error('Error al eliminar el tópico');
    return response;
  } catch (error) {
    console.error("Error al intentar eliminar el tópico:", error);
    throw error;
  }
};

export const fetchAdminTopics = async (username) => {
  try {
    const baseUrl = await buildEndpoint("API_ADMIN_FETCH_TOPIC");
    const API_URL = baseUrl.replace("{username}", encodeURIComponent(username));
    const response = await fetchWithAuth(API_URL);
    if (!response.ok) throw new Error("Error al cargar los tópicos de admin");
    const data = await response.json();
    return data.topics ? data.topics.map(t => ({ id: t.TOPIC_ID, name: t.TOPIC_NAME })) : data.map(t => ({ id: t.TOPIC_ID, name: t.TOPIC_NAME }));
  } catch (error) {
    console.error("Error al intentar cargar los tópicos de admin:", error);
    throw error;
  }
};

export const fetchAdminChatHistory = async (topicId, username) => {
  try {
    const baseUrl = await buildEndpoint("API_ADMIN_FETCH_CHAT_HISTORY");
    const API_URL = baseUrl
      .replace("{topic_id}", encodeURIComponent(topicId))
      .replace("{username}", encodeURIComponent(username));
    const response = await fetchWithAuth(API_URL);
    if (!response.ok) throw new Error("Error al cargar el historial de admin");
    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error al intentar cargar el historial de admin:", error);
    throw error;
  }
};

export const deleteAdminTopic = async (topicId, username) => {
  try {
    const baseUrl = await buildEndpoint("API_ADMIN_DELETE_TOPIC");
    const API_URL = `${baseUrl}/${encodeURIComponent(topicId)}/users/${encodeURIComponent(username)}`;
    const response = await fetchWithAuth(API_URL, { method: "DELETE" });
    if (!response.ok) throw new Error('Error al eliminar el tópico de admin');
    return response;
  } catch (error) {
    console.error("Error al intentar eliminar el tópico de admin:", error);
    throw error;
  }
};